import { BodyText, Button, TextInput } from '@unmind/design-system';
import { IndicatorError } from 'icons';
import { hideVisually, rem } from 'polished';
import styled, { css } from 'styled-components';
import { MIN_HEIGHT_CHAT_INPUT } from '../styles';

export const ChatBotTextInput = styled(TextInput)<{
  $displayOnHomepage: boolean;
}>`
  max-height: ${rem(144)};
  padding: ${rem(4)} ${rem(4)};

  ${({ $displayOnHomepage }) =>
    $displayOnHomepage &&
    css`
      min-height: ${MIN_HEIGHT_CHAT_INPUT};
    `}
`;

const sharedInputButtonStyles = `
  margin-left: auto;
  border: none;
  min-height: ${rem(36)};
  min-width: ${rem(36)};  
`;

export const VoiceButton = styled(Button)`
  &&&&.chatbot-input-voice-button {
    ${sharedInputButtonStyles}
    padding: 0;

    svg {
      color: ${({ theme }) => theme.colors.text.inverse};
      margin: 0;
      width: 1em;
      height: 1em;
      align-self: center;
    }
  }
`;

export const ChatSubmitButton = styled(Button)`
  &&&&.chatbot-input-submit-button {
    ${sharedInputButtonStyles}

    svg {
      color: ${({ theme }) => theme.colors.text.inverse};
      margin: 0;
      min-width: 1em;
      min-height: 1em;
      align-self: center;
      rotate: -90deg;
    }
  }
`;

export const ControlsContainer = styled.div`
  display: flex;
  width: 100%;
  gap: ${rem(12)};
  flex-wrap: wrap;
  > .hidden {
    ${hideVisually()}
  }
`;

export const StyleSelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(12)};
  flex-wrap: wrap;
`;

export const StyleSelectErrorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(4)};
`;

export const ErrorIcon = styled(IndicatorError).attrs(({ theme }) => ({
  width: 12,
  height: 12,
  primaryColor: theme.colors.staticPalette.white,
  secondaryColor: theme.colors.text.error,
}))`
  flex-shrink: 0;
`;

export const ErrorText = styled(BodyText).attrs(({ theme }) => ({
  color: theme.colors.text.error,
  sizes: [theme.typography.fontSizes.fontSize12],
  weight: theme.typography.fontWeights.semiBold,
}))`
  text-wrap: wrap;
`;
